exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cheetah-grid__warning-message-element {\n\tborder-top: solid 1px #dd2c00;\n\tcolor: #dd2c00;\n}\n", ""]);

// exports
